import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../AuthProvider';
import { normalizeAudioSettingLevel0to100 } from '../utils/applyAudioSettingsPatch';
import { VolumeSlider } from './VolumeSlider';

import '../pages/profile.css';

const GuestSettings: React.FC = () => {
    const { user, patchUserSettings } = useAuth();
    const navigate = useNavigate();

    const musicLevel = normalizeAudioSettingLevel0to100(user.settings?.music);
    const sfxLevel = normalizeAudioSettingLevel0to100(user.settings?.sfx);

    return (
        <div className="settings_container">
            <div className="settings_options" aria-label="Guest settings">
                <div className="settings_option">
                    <label className="settings_label" htmlFor="guest-settings-music">
                        Music:
                    </label>
                    <VolumeSlider
                        id="guest-settings-music"
                        value={musicLevel}
                        onChange={(v) => {
                            void patchUserSettings({ music: v });
                        }}
                    />
                </div>
                <div className="settings_option">
                    <label className="settings_label" htmlFor="guest-settings-sfx">
                        Sound Effects:
                    </label>
                    <VolumeSlider
                        id="guest-settings-sfx"
                        value={sfxLevel}
                        onChange={(v) => {
                            void patchUserSettings({ sfx: v });
                        }}
                    />
                </div>
            </div>
            <div className="settings_bottom guest_settings_actions">
                <button
                    type="button"
                    className="button_std"
                    onClick={() => navigate('/createaccount')}
                >
                    Create Account
                </button>
                <button type="button" className="button_std" onClick={() => navigate('/login')}>
                    Log in
                </button>
            </div>
        </div>
    );
};

export default GuestSettings;
